import { render } from "./basic.vue?vue&type=template&id=5b0a38b2&scoped=true"
import script from "./basic.vue?vue&type=script&lang=js"
export * from "./basic.vue?vue&type=script&lang=js"

import "./basic.vue?vue&type=style&index=0&id=5b0a38b2&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b0a38b2"]])

export default __exports__